import { useState, useEffect } from 'react'
import { apiClient } from '../api/client'
import type { CommentListResponse } from '../api/types'

/**
 * コメント一覧取得フック
 *
 * 日付フィルタとページネーションをサポート。
 */
export function useComments(filters: {
  startDate?: string
  endDate?: string
}) {
  const [data, setData] = useState<CommentListResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchComments = async (cursor?: string) => {
    setLoading(true)
    setError(null)

    try {
      const result = await apiClient.getComments({
        ...filters,
        cursor,
        limit: 20,
      })

      if (cursor && data) {
        // ページネーション: 既存データに追加
        setData({
          comments: [...data.comments, ...result.comments],
          nextCursor: result.nextCursor,
        })
      } else {
        // 初回読み込み: データを置き換え
        setData(result)
      }
    } catch (err) {
      setError(err as Error)
    } finally {
      setLoading(false)
    }
  }

  // フィルタ変更時に再取得
  useEffect(() => {
    fetchComments()
  }, [filters.startDate, filters.endDate])

  const loadMore = () => {
    if (data?.nextCursor && !loading) {
      fetchComments(data.nextCursor)
    }
  }

  return { data, loading, error, loadMore }
}
